import _ from "@lodash";
import { AppBar, DialogActions, DialogContent, IconButton, Toolbar, Typography } from "@material-ui/core";
import XAPPDialog from "app/Core/Components/Dialog/XAPPDialog";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import * as AppActions from "app/store/actions";
import TarefaApontamentoPedidoEmAberto from "app/Workflow/TarefaApontamento/TarefaApontamentoPedidoEmAberto";
import MobileDetect from "mobile-detect";
import React from "react";
import { MdClose } from "react-icons/md";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import GerenciadorProcessoApp from "../../GerenciadorProcesso/GerenciadorProcessoApp";
import * as Actions from "../Store/Actions/MinhasTarefasActions";

const md = new MobileDetect(window.navigator.userAgent);

class CheckoutDialog extends XAPPComponent {

    state = null;

    componentDidUpdate() {
        const { open } = this.props;
        if (_.isNull(this.state) && !_.isNull(open)) {
            this.setState(open);
        }
    }

    onClose = () => {
        this.props.openDialog(null);
        this.props.listFilter();
    };

    canBeSubmitted = () => {
        return true;
    };

    getNextStep = (_AID) => {
        const { getTarefa, xappRouteParams, parametros } = this.props;
        getTarefa(_AID, xappRouteParams, parametros);
    };

    onChangePedido = (_AItem = null, _AObject = null) => {
        if (!_.isNull(_AItem)) {
            let AArray = { ...this.state.pedidoquantidade };
            AArray[_AItem.idtarefaprocessoapontamentoitem] = _AItem.quantidaderealizado;
            if (_AItem.quantidaderealizado === 0) {
                delete AArray[_AItem.idtarefaprocessoapontamentoitem];
            }
            this.setState(_.set({ ...this.state }, "pedidoquantidade", AArray));
        }
        if (!_.isNull(_AObject)) {
            this.setState(_.set({ ...this.state }, "pedidoquantidade", _AObject));
        }
    };

    render() {
        const { xappRouteParams, parametros } = this.props;
        const form = this.state;

        return (
            <React.Fragment>
                <XAPPDialog
                    id="Checkout"
                    onClose={this.onClose}
                    open={!_.isNull(form)}
                    fullWidth
                    fullScreen={md.mobile() !== null}
                    maxWidth="md"
                >
                    <AppBar position="static" elevation={1}>
                        <Toolbar className="flex w-full min-h-0">
                            <Typography variant="subtitle1 text-white">
                                {!_.isNull(form) && form.jsonpasso && form.jsonpasso.titulo}
                            </Typography>
                            <div style={{ flex: 1 }} />
                            <IconButton
                                key="close"
                                aria-label="Close"
                                className="p-6"
                                onClick={this.onClose}
                            >
                                <MdClose className="text-20 text-white" />
                            </IconButton>
                        </Toolbar>
                    </AppBar>
                    <DialogContent classes={{ root: "p-0" }}>
                        {!_.isNull(form) &&
                            <TarefaApontamentoPedidoEmAberto
                                xappRouteParams={xappRouteParams}
                                idtarefaprocesso={form.idtarefaprocesso}
                                idpessoaformulario={form.idpessoaformulario}
                                onChange={this.onChangePedido}
                                pedidoquantidade={form.pedidoquantidade}
                            />
                        }
                    </DialogContent>
                    {!_.isNull(form) && (_.isUndefined(form.conclusao) || _.isNull(form.conclusao) || [666, 999].includes(form.passofluxo)) &&
                        <AppBar position="static" elevation={3} color="textSecondary">
                            <Toolbar className="flex w-full justify-end min-h-0">
                                <DialogActions className="gap-6">
                                    {((_.isUndefined(form.conclusao) || _.isNull(form.conclusao)) && form.idfluxo !== null) &&
                                        <GerenciadorProcessoApp
                                            Tarefa={form}
                                            passofluxo={form.passofluxo}
                                            xappRouteParams={xappRouteParams}
                                            getNext={this.getNextStep}
                                            close={this.onClose}
                                            canBeSubmitted={this.canBeSubmitted}
                                            parametros={parametros}
                                        />
                                    }
                                </DialogActions>
                            </Toolbar>
                        </AppBar>
                    }
                </XAPPDialog>
            </React.Fragment>
        );
    }
}


function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getTarefa: Actions.getTarefa,
        saveTarefa: Actions.saveTarefa,
        showMessage: AppActions.showMessage,
        hideMessage: AppActions.hideMessage,
    }, dispatch);
}

function mapStateToProps({ MinhasTarefas, auth }) {
    return {
        user: auth.user.data,
        formDialog: MinhasTarefas.MinhasTarefasReducer.formDialog,
        pedido: MinhasTarefas.MinhasTarefasReducer.pedido,
    };
}


export default connect(mapStateToProps, mapDispatchToProps)(CheckoutDialog);
